import PropTypes from 'prop-types';
import { useEffect } from 'react';

import Text from 'shopper/components/Text';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const EmptyList = ({ gaEventCategory }) => {
  useEffect(() => {
    sendEvent({ action: 'unavaliable_appear', category: gaEventCategory });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center gap-y-8">
      <Image
        alt="Pessoas montando em um quebra cabeça"
        className="md:size-44"
        height={168}
        src={`${APP.LOCAL_IMAGE_PATH}/features/store/empty-list.svg`}
        width={168}
        priority
      />
      <Text>{placeholder('empty.storeOffers')}</Text>
    </div>
  );
};

EmptyList.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default EmptyList;
